/* eslint-disable no-underscore-dangle */

export default {
  namespaced: true,
  state: {
    activeConnections: [],
  },
  getters: {
    routeConnections: state => routeName =>
      state.activeConnections.filter(connection => connection.currentPage === routeName),
  },
  mutations: {
    setActiveConnections(state, connections) {
      state.activeConnections = connections
    },
    addActiveConnection(state, connection) {
      state.activeConnections.push(connection)
    },
    removeActiveConnection(state, connection) {
      const index = state.activeConnections.findIndex(
        activeConnection => activeConnection.socketId === connection.socketId,
      )
      if (index > -1) {
        state.activeConnections.splice(index, 1)
      }
    },
    pageChanged(state, { socketId, pageName }) {
      const index = state.activeConnections.findIndex(activeConnection => activeConnection.socketId === socketId)
      if (index > -1) {
        state.activeConnections[index].currentPage = pageName
      }
    },
  },
  actions: {
    GET_ACTIVE_CONNECTIONS({ commit }) {
      this._vm.$socket.client.emit('getActiveConnections', connections => {
        commit('setActiveConnections', connections)
      })
    },
    CHANGE_PAGE({ commit }, { pageName }) {
      this._vm.$socket.client.emit('changePage', pageName)
      commit('pageChanged', { socketId: this._vm.$socket.client.id, pageName })
    },
    SOCKET_SERVICE_ROOM_JOINED: ({ commit }, connection) => {
      commit('addActiveConnection', connection)
    },
    SOCKET_SERVICE_ROOM_LEFT: ({ commit }, connection) => {
      commit('removeActiveConnection', connection)
    },
    SOCKET_PAGE_CHANGED: ({ commit }, payload) => {
      commit('pageChanged', payload)
    },
  },
}
